import { apiInstance3, javaApiInstance } from 'utils/request'
import parseError from 'helpers/parseServerError'

const NETWORK_PROGRAMS_PATH = '/admin/v1/network-programs'
const NETWORK_PROGRAM_GOALS_PATH = '/admin/v1/network-program-goals'
const NETWORK_PROGRAM_FEATURES_PATH = '/admin/v1/network-program-features'

export const getEarnOffers = ({ page, perPage, search, network, programStatus, approvalStatus, sort, offerType }) => {
  const params = {
    page,
    per_page: perPage,
    offer_type: offerType,
  }
  if (search) params.search = search
  if (network) params.network = network
  if (programStatus) params.program_status = programStatus
  if (approvalStatus) params.approval_status = approvalStatus
  if (sort) params.sort = sort

  return apiInstance3
    .get('/backoffice/earn/offers', { params })
    .catch((error) => {
      parseError(error, 'Cannot get earn offers')
    })
}

export const getEarnNetworks = () => {
  return apiInstance3
    .get('/backoffice/earn/offers/networks')
    .catch((error) => {
      parseError(error, 'Cannot get earn networks')
    })
}

// Game genre catalog (Java) — bare array of { value, label }
export const getGameGenres = () => {
  return javaApiInstance
    .get('/admin/v1/game-genres')
    .catch((error) => {
      parseError(error, 'Cannot get game genres')
    })
}

export const bulkApproveOffers = (ids) => {
  return apiInstance3
    .post('/backoffice/earn/offers/bulk_approve', { ids })
    .catch((error) => {
      parseError(error, 'Cannot approve offers')
      throw error
    })
}

export const bulkDeclineOffers = (ids) => {
  return apiInstance3
    .post('/backoffice/earn/offers/bulk_decline', { ids })
    .catch((error) => {
      parseError(error, 'Cannot decline offers')
      throw error
    })
}

export const bulkUndoOffers = (ids) => {
  return apiInstance3
    .post('/backoffice/earn/offers/bulk_undo', { ids })
    .catch((error) => {
      parseError(error, 'Cannot undo offers')
      throw error
    })
}

// KarmaEarn NetworkProgram admin CRUD (Java backend)
export const getNetworkProgram = (id) => {
  return javaApiInstance
    .get(`${NETWORK_PROGRAMS_PATH}/${id}`)
    .catch((error) => {
      parseError(error, 'Cannot load program')
      throw error
    })
}

export const createNetworkProgram = (data) => {
  return javaApiInstance
    .post(NETWORK_PROGRAMS_PATH, data)
    .catch((error) => {
      parseError(error, 'Cannot create program')
      throw error
    })
}

export const updateNetworkProgram = ({ id, data }) => {
  return javaApiInstance
    .put(`${NETWORK_PROGRAMS_PATH}/${id}`, data)
    .catch((error) => {
      parseError(error, 'Cannot update program')
      throw error
    })
}

export const deleteNetworkProgram = (id) => {
  return javaApiInstance
    .delete(`${NETWORK_PROGRAMS_PATH}/${id}`)
    .catch((error) => {
      parseError(error, 'Cannot delete program')
      throw error
    })
}

// KarmaEarn NetworkProgramGoal admin CRUD (Java backend)
export const getNetworkProgramGoal = (id) => {
  return javaApiInstance
    .get(`${NETWORK_PROGRAM_GOALS_PATH}/${id}`)
    .catch((error) => {
      parseError(error, 'Cannot load goal')
      throw error
    })
}

export const createNetworkProgramGoal = (data) => {
  return javaApiInstance
    .post(NETWORK_PROGRAM_GOALS_PATH, data)
    .catch((error) => {
      parseError(error, 'Cannot create goal')
      throw error
    })
}

export const updateNetworkProgramGoal = ({ id, data }) => {
  return javaApiInstance
    .put(`${NETWORK_PROGRAM_GOALS_PATH}/${id}`, data)
    .catch((error) => {
      parseError(error, 'Cannot update goal')
      throw error
    })
}

export const deleteNetworkProgramGoal = (id) => {
  return javaApiInstance
    .delete(`${NETWORK_PROGRAM_GOALS_PATH}/${id}`)
    .catch((error) => {
      parseError(error, 'Cannot delete goal')
      throw error
    })
}

// KarmaEarn NetworkProgramFeature admin (Java backend) — genres
export const createNetworkProgramFeature = (data) => {
  return javaApiInstance
    .post(NETWORK_PROGRAM_FEATURES_PATH, data)
    .catch((error) => {
      parseError(error, 'Cannot add genre')
      throw error
    })
}

export const deleteNetworkProgramFeature = (id) => {
  return javaApiInstance
    .delete(`${NETWORK_PROGRAM_FEATURES_PATH}/${id}`)
    .catch((error) => {
      parseError(error, 'Cannot remove genre')
      throw error
    })
}
